import type { PatientFormValues } from "./PatientForm";

/**
 * Normaliza o form pra payload do tRPC — strings vazias viram undefined
 * pra o schema zod nao reclamar, e birthDate string ISO vira Date.
 */
export function buildPatientPayload(v: PatientFormValues) {
  const emptyAsUndefined = (s: string) => (s ? s : undefined);
  return {
    name: v.name.trim(),
    identifier: emptyAsUndefined(v.identifier),
    clinicalRecordNumber: emptyAsUndefined(v.clinicalRecordNumber),
    document: emptyAsUndefined(v.document),
    sex: (v.sex || undefined) as "M" | "F" | "OTHER" | undefined,
    birthDate: v.birthDate ? new Date(v.birthDate) : undefined,
    phone: emptyAsUndefined(v.phone),
    landline: emptyAsUndefined(v.landline),
    whatsapp: emptyAsUndefined(v.whatsapp),
    contatoDeEmergenciaNome: emptyAsUndefined(v.contatoDeEmergenciaNome.trim()),
    contatoDeEmergenciaTelefone: emptyAsUndefined(v.contatoDeEmergenciaTelefone),
    email: emptyAsUndefined(v.email),
    zipCode: emptyAsUndefined(v.zipCode),
    address: emptyAsUndefined(v.address),
    addressNumber: emptyAsUndefined(v.addressNumber),
    addressComplement: emptyAsUndefined(v.addressComplement),
    neighborhood: emptyAsUndefined(v.neighborhood),
    city: emptyAsUndefined(v.city),
    state: (v.state || undefined) as never,
    profession: emptyAsUndefined(v.profession),
    motherName: emptyAsUndefined(v.motherName),
    insurancePlanName: emptyAsUndefined(v.insurancePlanName),
    insurancePlanNumber: emptyAsUndefined(v.insurancePlanNumber),
    avatarUrl: v.avatarUrl,
    tags: v.tags,
    howDidMeet: emptyAsUndefined(v.howDidMeet),
    notes: emptyAsUndefined(v.notes),
    active: v.active,
    semCpf: v.estrangeiro || undefined,
  };
}

export function patientToFormValues(p: any): PatientFormValues {
  return {
    name: p.name ?? "",
    identifier: p.identifier ?? "",
    clinicalRecordNumber: p.clinicalRecordNumber ?? "",
    document: p.document ?? "",
    sex: (p.sex ?? "") as PatientFormValues["sex"],
    birthDate: p.birthDate ? new Date(p.birthDate).toISOString().slice(0, 10) : "",
    phone: p.phone ?? "",
    landline: p.landline ?? "",
    whatsapp: p.whatsapp ?? "",
    contatoDeEmergenciaNome: p.contatoDeEmergenciaNome ?? "",
    contatoDeEmergenciaTelefone: p.contatoDeEmergenciaTelefone ?? "",
    email: p.email ?? "",
    zipCode: p.zipCode ?? "",
    address: p.address ?? "",
    addressNumber: p.addressNumber ?? "",
    addressComplement: p.addressComplement ?? "",
    neighborhood: p.neighborhood ?? "",
    city: p.city ?? "",
    state: p.state ?? "",
    profession: p.profession ?? "",
    motherName: p.motherName ?? "",
    insurancePlanName: p.insurancePlanName ?? "",
    insurancePlanNumber: p.insurancePlanNumber ?? "",
    avatarUrl: p.avatarUrl ?? null,
    tags: p.tags ?? [],
    howDidMeet: p.howDidMeet ?? "",
    notes: p.notes ?? "",
    active: p.active ?? true,
    // Documento que não é CPF (11 dígitos) só pode ter vindo do modo estrangeiro.
    estrangeiro: !!p.document && !/^d{11}$/.test(p.document),
  };
}
